// TODO-NT Make component of this instead of container
import React, { Component } from 'react';
import ModalFull from '../../components/helpers/ModalFull';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as selectors from '../../selectors/events/filter';
import {
    selectPartner,
    toggleTimeView,
    toggleListView,
    toggleAll,
    openViewFilter,
    closeViewFilter,
} from '../../actions/events/filter';
import SelectPartner from '../../components/application/timetable/filter/SelectPartner';
import listIcon from '../../assets/images/list_view.svg';
import blockIcon from '../../assets/images/block_view.svg';

class ViewFiltersMobile extends Component {
    render() {
        return (
            <ModalFull
                className="rp-hidden-1200-plus"
                open={this.props.viewFilterOpen}
                onClose={this.props.closeViewFilter}
            >
                <div className="ckp-events-filter">
                    <div>
                        <div className="ckp-events-filter-title-group">
                            <h2 className="ckp-events-filter-title ckp-ts-h4">Layout</h2>
                        </div>
                        <ul className="ckp-timetable-actions-group is-dark">
                            <li
                                onClick={!this.props.isInLiveView ? this.props.toggleTimeView : null}
                                className={`ckp-timetable-actions-option ${
                                    this.props.isInLiveView ? 'is-selected' : ''
                                }`}
                            >
                                Live View
                            </li>
                            <li
                                onClick={this.props.isInLiveView ? this.props.toggleTimeView : null}
                                className={`ckp-timetable-actions-option ${
                                    this.props.isInLiveView ? '' : 'is-selected'
                                }`}
                            >
                                Post Event View
                            </li>
                        </ul>
                        <div className="ckp-events-filter-title-group">
                            <h2 className="ckp-events-filter-title ckp-ts-h4">View</h2>
                        </div>
                        <ul className="ckp-timetable-actions-group is-dark">
                            <li
                                onClick={this.props.isInListView ? this.props.toggleListView : null}
                                className={`ckp-timetable-actions-option ${
                                    this.props.isInListView ? '' : 'is-selected'
                                }`}
                            >
                                <img src={blockIcon} alt="Timetable view" />
                            </li>
                            <li
                                onClick={!this.props.isInListView ? this.props.toggleListView : null}
                                className={`ckp-timetable-actions-option ${
                                    this.props.isInListView ? 'is-selected' : ''
                                }`}
                            >
                                <img src={listIcon} alt="List view" />
                            </li>
                        </ul>
                    </div>
                    {this.props.partners.length > 1 ? (
                        <div className="rp-hidden-1200-plus">
                            <h2 className="ckp-events-filter-title ckp-ts-h4">View lineup as</h2>
                            <ul className="ckp-events-filter-options">
                                {this.props.partners.map((p) => (
                                    <SelectPartner
                                        selectPartner={this.props.selectPartner}
                                        key={p.id}
                                        selected={this.props.selectedPartner}
                                        partner={p}
                                    />
                                ))}
                            </ul>
                        </div>
                    ) : null}
                </div>
            </ModalFull>
        );
    }
}

const mapStateToProps = (state) => ({
    partners: selectors.filterPartnersSelector(state),
    selectedPartner: selectors.filterSelectedPartnerSelector(state),
    viewFilterOpen: selectors.viewFilterOpenSelector(state),
    isInLiveView: selectors.liveViewSelector(state),
    isInListView: selectors.listViewSelector(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { selectPartner, toggleTimeView, toggleListView, toggleAll, closeViewFilter, openViewFilter },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ViewFiltersMobile);



// WEBPACK FOOTER //
// ./src/containers/events/ViewFiltersMobile.js